import { Component, Input } from '@angular/core';
import { CompanyShortInterest } from '../../models/company/company-short-interest.model';

@Component({
    selector: 'rms-htb-flag',
    templateUrl: './htb-flag.component.html',
    styleUrls: ['./htb-flag.component.scss'],
    standalone: false
})
export class HtbFlagComponent {

  @Input() companyShortInterest: CompanyShortInterest;

  /**
   * Hard to Borrow constants for below calculation:
   * Market Cap < $300M OR
   * Last <$2/sh OR
   * Short Interest (%)  >30% OR
   * Benchmark Rate >10% OR
   * Utilization (%) >90% OR
   * Days to Cover 10bps NAV short in RAHF >30 Days
   */
  public readonly MARKET_CAP_COMPARE = 300000000;
  public readonly LAST_TRADE_COMPARE = 2;
  public readonly SHORT_INTEREST_COMPARE = 30;
  public readonly BENCHMARK_RATE_COMPARE = 10;
  public readonly UTILIZATION_COMPARE = 90;
  public readonly RA_DAYS_TO_COVER_COMPARE = 30;
}
